import { render, staticRenderFns } from "./GrupoList.vue?vue&type=template&id=d92b856a"
import script from "./GrupoList.vue?vue&type=script&lang=js"
export * from "./GrupoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports